import styled from '@emotion/styled';

export const Container = styled.div<{ size: number }>`
  width: ${(props) => props.size + 'px'};
  height: ${(props) => props.size + 'px'};
  flex-shrink: 0;
`;
